import zhTwLocale from "element-ui/lib/locale/lang/zh-TW";
const tw = {
  message: {
    lan: "Tw",
    errorMessage: {
      ServerException: "服務器異常",
      ClientException: "客戶端異常",
      NetworkException: "未知網絡異常",
      CheckNetwork: "請檢查網絡",
      UnknownError: "未知錯誤",
      captchaError: "驗證碼錯誤！請重新輸入"
    },
    index: "首頁",
    course_learning: "課程學習及進度",
    course_learn: "課程學習",
    viewed_times: "瀏覽次數",
    course_catalog: "課程目錄",
    learning_progress: "學習進度",
    view_exam_record: "查看模擬考試記錄",
    learn_review: "學習回顧",
    continue_learning: "繼續學習",
    to_learn: "去學習",
    take_the_mock_test: "參與模擬考試",
    replay: "重播",
    play: "播放",
    pause: "暫停",
    muteMe: "靜音",
    sound: "聲音",
    search_chapter_placeholder: "請輸入標題",
    practice_test: "模擬考試",
    exam_record: "模擬考試記錄",
    course_name: "課程名稱",
    exam_score: "測驗分數",
    operation_time: "操作時間",
    view: "查看",
    title_TRUE_OR_FALSE: "是非題",
    title_SINGLE_CHOICE: "單選題",
    title_SHORT_ANSWER: "簡答題",
    title_MULTIPLE_CHOICE: "多選題",
    correct: "正確",
    wrong: "錯誤",
    correct_answer: "回答正確",
    wrong_answer: "回答錯誤",
    right_key: "正確答案",
    submit_test: "提交試卷",
    next_question: "下一題",
    back: "返回",
    exam_result: "考試結果",
    answers_situation: "答題情況",
    return_exam_record: "返回模擬考試記錄",
    reTest: "重新考試",
    back_to_home: "返回主頁",
    all: "全部",
    learning: "學習中",
    finished_learning: "已學完",
    submit: "提交",
    logout: "登出",
    course_list: "課程列表",
    prev_section: "上一節",
    next_section: "下一節",
    start_chapter_learn: "進入本章學習",
    return_prev_chapter: "返回上一章節",
    return_this_chapter: "返回本章",
    start_next_chapter: "進入下一章",
    to_test: "進入模擬考試",
    chapter_start: "本章開始",
    chapter_end: "本章結束",
    copyright: "澳門特別行政區政府勞工事務局版權所有",
    course_entry: "進入課程",
    start_test: "開始考試",
    test_tips: "課程進度不足80%，請耐心學習再參與考試",
    question_tips: "課程進度不足80%，請耐心學習再參與問卷",

    tips: "提示",
    confirm: "確認",
    question_already: "每份問卷只能填寫一次",

    exam_excellent: "恭喜，你的模擬考試分數優秀",
    exam_pass: "加油，你的模擬考試分數合格",
    exam_fail: "請繼續努力，你的模擬考試分數不理想",

    submit_success: "提交成功",
    submit_error: "提交失敗",

    learning_content: "學習內容",

    priority_tips: "推薦按以下順序學習課程",
    goto_course: "前往課程",
    current: "(當前)",
    no_question: "獲取題目失敗",
    public_questionnaires_Invalid: "問卷已失效或未生效！",

    web_title: "勞工事務局eLearning",
    question_public_title: "勞工事務局",
    online_services: "網上報名",
    write_tips: "請填寫課後問卷，以便本局持續改善本網上學習課程，謝謝！",
    chapter: "第{0}章",
    section: "第{0}節",
    question_must_be_completed: "問卷需填寫完才能提交",
    captcha_plh: "請輸入驗證碼",
    noData: "暫無數據",
    question: "問卷調查",
    noVoice: "No voice",
    numberToCN: [
      "〇",
      "一",
      "二",
      "三",
      "四",
      "五",
      "六",
      "七",
      "八",
      "九",
      "十",
      "十一",
      "十二",
      "十三",
      "十四",
      "十五",
      "十六",
      "十七",
      "十八",
      "十九",
      "二十",
      "二十一",
      "二十二",
      "二十三",
      "二十四",
      "二十五",
      "二十六",
      "二十七",
      "二十八",
      "二十九",
      "三十",
      "三十一",
      "三十二",
      "三十三",
      "三十四",
      "三十五",
      "三十六",
      "三十七",
      "三十八",
      "三十九",
      "四十",
      "四十一",
      "四十二",
      "四十三",
      "四十四",
      "四十五",
      "四十六",
      "四十七",
      "四十八",
      "四十九",
      "五十",
      "五十一",
      "五十二",
      "五十三",
      "五十四",
      "五十五",
      "五十六",
      "五十七",
      "五十八",
      "五十九"
    ],
    question_tips_content: "為了讓「<b>{0}</b>」eLearning學習系統更加完善，誠邀您協助填寫一份問卷，您的寶貴意見將能令我們的服務做得更好，謝謝！",
    question_tips_btn1: "點擊這裡進入填寫問卷",
    question_tips_btn2: "未完成全部學習，稍後再填寫",
  },
  ...zhTwLocale
};

export default tw;
